import styled from "styled-components";

const DivMarginCenter = styled.div`
  text-align: center;
  margin-top: 30px;
`;

export default DivMarginCenter;
